
document.addEventSelectorListener("change", "[data-accordion]", function(event, target) {
	var elements = document.querySelectorAll("[data-" + target.getAttribute("data-accordion") + "='" + target.value + "']");
	var others = document.querySelectorAll("[data-" + target.getAttribute("data-accordion") + "]");

	for (var i = 0; i < others.length; ++i) {
		others[i].classList.add("d-none");
	}
	for (var i = 0; i < elements.length; ++i) {
		elements[i].classList.remove("d-none");
	}

	for (var i = 0; i < others.length; ++i) {
		var radios = others[i].querySelectorAll("input[type='radio']");
		for (var j = 0; j < radios.length; ++j) {
			radios[j].checked = false;
		}
	}
	for (var i = 0; i < elements.length; ++i) {
		var radio = elements[i].querySelector("input[type='radio']");
		if (radio) {
			radio.checked = true;
		}
	}
});

document.addEventSelectorListener("change", "[data-radio-reveal]", function(event, target) {
	var targets = document.querySelectorAll(target.getAttribute("data-radio-reveal"));
	var parents = document.querySelectorAll(target.getAttribute("data-radio-reveal-parent"));
	var others = document.querySelectorAll(target.getAttribute("data-radio-reveal-others"));

	if (targets.length) {
		for (var i = 0; i < others.length; ++i) {
			others[i].classList.add("d-none");
		}
		for (var i = 0; i < targets.length; ++i) {
			targets[i].classList.remove("d-none");
		}
		for (var i = 0; i < parents.length; ++i) {
			parents[i].classList.remove("d-none");
		}
	}
	else {
		for (var i = 0; i < others.length; ++i) {
			others[i].classList.add("d-none");
		}
		for (var i = 0; i < parents.length; ++i) {
			parents[i].classList.add("d-none");
		}
	}
});
